// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__29bE3","form":"styles_form__3fH1L"};